import { render, staticRenderFns } from "./MaterialListEdit.vue?vue&type=template&id=3651ae56&scoped=true"
import script from "./MaterialListEdit.vue?vue&type=script&lang=js"
export * from "./MaterialListEdit.vue?vue&type=script&lang=js"
import style0 from "./MaterialListEdit.vue?vue&type=style&index=0&id=3651ae56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3651ae56",
  null
  
)

export default component.exports